var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "category-main-app" },
    [
      _vm.isMainPage
        ? _c(
            "common-desktop-element",
            { staticClass: "category-main-app__menu-wrapper vn-grid-medium" },
            [
              _c("category-menu", {
                staticClass: "category-main-app__menu",
                attrs: { categoryList: _vm.menu }
              })
            ],
            1
          )
        : _c(
            "div",
            { staticClass: "category-main-app__menu-wrapper vn-grid-medium" },
            [
              _c("category-menu", {
                staticClass: "category-main-app__menu",
                attrs: { categoryList: _vm.menu }
              })
            ],
            1
          ),
      _vm._v(" "),
      _vm._l(_vm.list, function(category) {
        return [
          category
            ? _c(
                "div",
                { key: category.id },
                [
                  _c("div", { staticClass: "category-header vn-grid-medium" }, [
                    _c("h5", { staticClass: "category-title" }, [
                      _vm._v(_vm._s(category.title))
                    ]),
                    _vm._v(" "),
                    category.courses.length > _vm.DISPLAYING_LIMIT
                      ? _c(
                          "a",
                          {
                            staticClass: "category-link-all",
                            attrs: { href: category.slug }
                          },
                          [_vm._v("\n          전체보기 >\n        ")]
                        )
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("course-card-carousel", {
                    staticClass: "vn-grid-medium vn-grid-medium-carousel",
                    attrs: { courseList: category.courses }
                  })
                ],
                1
              )
            : _vm._e()
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }